import { useEffect } from "react";

// TODO: Adopt this hook in other click-outside locations:
// - src/stores/RightClickMenuStore.js
// - src/components/StageView/index.jsx
// - src/components/DevTools/RefluxMonitoring/RefluxMonitoring.jsx
// - src/components/DesignSettings/DesignSettingsModal.jsx

/**
 * Calls a callback when a click occurs outside the referenced element.
 * Uses composedPath to support shadow DOM elements.
 * @param {React.RefObject<HTMLElement>} ref - Ref to the element to detect clicks outside of
 * @param {Function} onClickOutside - Callback fired on outside click
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true] - Whether the listener is active
 * @param {number} [options.delay=0] - Delay in ms before attaching listeners
 * @param {boolean} [options.listenForContextMenu=false] - Also listen for right-click
 */
const useClickOutside = (ref, onClickOutside, { enabled = true, delay = 0, listenForContextMenu = false } = {}) => {
  useEffect(() => {
    if (!enabled) return;

    const handleClick = (event) => {
      const element = ref.current;
      if (!element) return;

      const path = event.composedPath();
      if (!path.some((el) => el === element)) {
        onClickOutside(event);
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener("click", handleClick);
      if (listenForContextMenu) {
        document.addEventListener("contextmenu", handleClick);
      }
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("click", handleClick);
      if (listenForContextMenu) {
        document.removeEventListener("contextmenu", handleClick);
      }
    };
  }, [ref, onClickOutside, enabled, delay, listenForContextMenu]);
};

export default useClickOutside;
